export default "__VITE_ASSET__LUlqezUf__"